import React from "react";
import NavigationBar from "../components/navigationbar";
import Footer from "../components/footer";
import { Container, Row, Col } from "react-bootstrap";
import freezer from "../assets/freezer.png";
import AlphaJuice from "../components/alphajuice";

export const EidAlAdha = () => {
  return (
    <div style={{ backgroundColor: "#f4f4f4" }}>
      <NavigationBar />

      <Container className="my-5">
        <Row className="mb-4 py-4" style={{ backgroundColor: "#235405" }}>
          <Col className="text-center">
            <h1 className="text-white fw-bold">Eid al-Adha: Udhiya Distribution by GAMRC</h1>
            <h5 className="text-white mt-3">As-Salaamu Alaikum Wa Rahmatullahi Wa Barakatuhu</h5>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <p className="lead">
              Qurbani Guidelines from the Greater Austin Muslim Relief Committee (GAMRC):
            </p>
            <p>
              As in previous years, the GAMRC — your zakat committees from Nueces Mosque, ICGA, GIC, ICRR, ICBC, ICLT, QCIC, ICHC, Al-Noor MC, — is pleased to assist with your Qurbani meat distribution.
            </p>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <h3 className="text-success fw-bold">Option 1: Slaughter via Local Market</h3>
            <ul>
              <li>Visit one of the following halal markets:</li>
              <ul>
                <li>International Foods Market <a href="https://maps.app.goo.gl/NgYKRY928qHXLaSx7">(Austin)</a></li>
                <li>IndoPak Halal Supermarket <a href="https://maps.app.goo.gl/qXB8auUxNB3P9if69">(Round Rock)</a></li>
                <li>Quality Halal <a href="https://maps.app.goo.gl/E4xcB3JzJjdP4czY9">(Cedar Park)</a></li>
                <li>World Food and Halal Market <a href="https://maps.app.goo.gl/Me5kcLqCxHZThZ998">(Austin)</a></li>
                <li>Manpasand (ALL Locations) (512) 781-0702 <br />
                  <a href="https://maps.app.goo.gl/V64sHYSiL2bnPKW28">12625 N Interstate Hwy 35 Building A, Austin, TX 78753</a>  <br />
                  <a href="https://maps.app.goo.gl/auCKW215MzNy1ECC9">3945 North, 183 Lakeline Mall Dr, Austin, TX 78717</a> <br />
                  <a href="https://maps.app.goo.gl/AVpEwwUkRgcwiWGx7">130 Sundance Pkwy, Round Rock, TX 78681</a> <br />
                </li>
              </ul>
              <li> Please tell the store owners how many bags you wish to donate and specify it is for Brother Amjad's collection. </li>
              <li>These stores will take your order, perform the slaughter on your behalf, and properly package the meat in 5 lb Ziploc bags.</li>
              <li>Prices may vary — please contact the stores directly.</li>
              <li><strong>Important:</strong> Let the store handle everything. DO NOT bring the meat home to sort or separate it.</li>
            </ul>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <h3 className="text-success fw-bold">Option 2: Slaughter By Yourself</h3>
            <p>If you plan to perform the sacrifice yourself and have GAMRC distribute the meat, please follow these guidelines:</p>
            <ul>
              <li>Ensure the meat is clean and properly cut.</li>
              <li>Use 1-gallon Ziploc bags (NOT grocery bags), and fill each with approximately 5 lbs of meat.</li>
              <li>Do not use small bags — <a href="https://www.amazon.com/gp/aw/d/B08ND6VHFW?ref=ppx_pt2_mob_b_prod_image">only full 1-gallon bags</a> are accepted.</li>
              <li>You may donate as many bags as you like.</li>
              <li>Please deliver the meat fresh or frozen for no more than 1–2 days (not after several months).</li>
            </ul>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={6}>
            <h4 className="text-success fw-bold">Drop-Off Locations</h4>
            <h4>
              Please do NOT drop off meat at the GAMRC Masajid. Please follow all the
              guidelines and drop off your Qurbani at the appropriate locations. The mosques DO NOT collect meat.
            </h4>
            <h4 style={{ color: 'red' }}>LAST DAY FOR DROP OFF IS May 31, 2026</h4>
            <div className="multi-column-list dropoff-list">
              <ul>
                <li>
                  <h3>Alpha Dessert Juice Cafe Austin</h3>
                  <a
                    href="https://maps.app.goo.gl/WRz8iwmM9wUTHC4Q6"
                    style={{ color: 'black' }}
                  >
                    1212 W Parmer Ln unit A, Austin, TX 78727
                  </a>
                </li>
              </ul>
              <h4>Make sure to drop off the bags in the freezer labeled BROTHER AMJAD'S COLLECTION</h4>
            </div> 
          </Col>

          <Col md={3}>
            <img
              src={freezer}
              alt="Freezer"
              className="img-fluid"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <h4 className="text-success fw-bold">Locations To Slaughter On Your Own</h4>
            <div className="multi-column-list">
              <ul>
                <li>
                  <strong>Brother Nooruddin Ali</strong><br />
                  Phone: 830-832-2657<br />
                  <a href="https://maps.app.goo.gl/f2gzgCQ6X2sPRySx5" target="_blank" rel="noreferrer">
                    2035 Ilka Switch, Seguin, TX 78155
                  </a>
                </li>

                <li>
                  <strong>Nicolas (Near Buda)</strong><br />
                  Phone: 512-227-4319<br />
                  <a href="https://maps.app.goo.gl/G6VDJAg99sjRENS38" target="_blank" rel="noreferrer">
                    2316 Misty Ln, Maxwell, TX 78656
                  </a>
                </li>

                <li>
                  <strong>Brother Ishtihaq</strong><br />
                  Phone: 512-554-5757<br />
                  Address: Text/WhatsApp for location<br />
                  Options: Cows ($350+), Lambs ($250+)
                </li>

                <li>
                  <strong>Brother Khalid</strong><br />
                  Phone: 512-690-6380<br />
                  <a href="https://maps.app.goo.gl/PpYcc1jdaRWYaNSGA" target="_blank" rel="noreferrer">
                    401 Phillip Ln, Liberty Hill, TX 78642
                  </a><br />
                  Prices: Large $450, Medium $400, Small $350
                </li>

                <li>
                  <strong>Brother Ali’s Farm (Ali’s Farm LLC)</strong><br />
                  Phone: 281-966-5327<br />
                  <a href="https://maps.app.goo.gl/C1JJgw3jTwHTAoFA6" target="_blank" rel="noreferrer">
                    6707 Brockstein Rd, Sealy, TX 77474
                  </a><br />
                  (Follow Brockstein Rd to the end of the gravel road)<br />
                  Facilities: Skinning, cutting, and packaging available
                </li>

                <li>
                  <strong>Kuti Livestock (Daniel)</strong><br />
                  Phone: 737-344-2751<br />
                  Address: Please call/text for location
                </li>

                <li>
                  <strong>Blue Nile Farms</strong><br />
                  Phone: 408-361-0323<br />
                  Only Lambs<br />
                  <a href="https://tinyurl.com/2djfdvnj" target="_blank" rel="noreferrer">Signup Form</a>
                </li>

                <li>
                  <strong>Gerald Moffet</strong><br />
                  Phone: 512-635-7071<br />
                  <a href="https://maps.app.goo.gl/XQYEtm95ZGXRM6RE6" target="_blank" rel="noreferrer">
                    FM 1174, Bertram, TX 78605
                  </a>
                </li>

                <li>
                  <strong>Mr. Wes / Jimmy (Father & Son)</strong><br />
                  Phone: 512-496-2410<br />
                  <a href="https://maps.app.goo.gl/xvcHsC5HCGCLsy3R9" target="_blank" rel="noreferrer">
                    1567 Watterson Rd, Red Rock, TX 78662
                  </a><br />
                  <em>Note: No butchers available – you must do the slaughtering, skinning, and cutting yourself.</em>
                </li>

                <li>
                  <strong>Ponderosa Pecan & Dorper Sheep Farm</strong><br />
                  Phone: (469) 233-1097 | (210) 823-3124<br />
                  <a href="https://www.google.com/maps/search/?api=1&query=540+Ponderosa+Rd,+Bastrop,+TX+78602" target="_blank" rel="noreferrer">
                    540 Ponderosa Rd, Bastrop TX 78602
                  </a><br />
                  Dorper Sheep — healthy, well-raised ram lambs<br />
                  Book early — call or text for an appointment
                </li>
              </ul>
            </div>


          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <h5 className="text-success fw-bold">Questions or Comments?</h5>
            <ul>
              <li>Email: <a href="mailto:info@austinzakat.org">info@austinzakat.org</a></li>
            </ul>
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <p className="fw-bold text-muted">
              Jazaakum Allahu Khairan — May Allah accept your sacrifice.
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
};

export default EidAlAdha;
